module.exports = __webpack_public_path__ + "img/checkbox-default-dark.1b44cf2.svg";